import styled from '@emotion/styled';

export const MainWrapper = styled('main', { label: 'MainWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
`;
